<template>
  <a-card :bordered='false'>
    <a-tabs>
      <a-tab-pane key="1" tab="消息管理">
      <management />
      </a-tab-pane>
      <a-tab-pane key="2" tab="接收人管理">
      <receiver />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import management from './management/index' 
import receiver from './receiver/index'
export default {
  name:"sub",
  components:{receiver,management}
}
</script>